import { render, staticRenderFns } from "./PcPage.vue?vue&type=template&id=7071ba68&scoped=true"
import script from "./PcPage.vue?vue&type=script&lang=js"
export * from "./PcPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071ba68",
  null
  
)

export default component.exports